import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { LandRightsFormNew, LandRightsSubmitPayload } from './land-rights-form-new';

export type LandRightsDrawerProps = {
  readonly formId: string;
  readonly project: Project;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly isOpen: boolean;
};

export function LandRightsDrawerNew({formId, project, onSubmit, onClose, isOpen }: LandRightsDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Land Rights')} open={isOpen} onClose={onClose} footer={footer}>
      <LandRightsFormNew
        id={formId}
        project={project}
        onSubmit={(data: LandRightsSubmitPayload) => {
          onSubmit(data, t('Land Rights section has been updated'));
        }}
      />
    </Drawer>
  );
}
